module.exports = __webpack_public_path__ + "static/media/pic_4_22.3cc497e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_4_22.jpg
// module id = 1837
// module chunks = 0 1